import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPageAuthValidarCodigo } from '@/features/catalogo/page/auth/CatalogoPageAuthValidarCodigo';

export const Route = createFileRoute('/p/catalogo/$slug/auth/validar-codigo')({
    component: CatalogoPageAuthValidarCodigo,
});
